/**
 * Mapping aciton from ngrx ionic storage plugin action
 */
export enum StorageNativeStoreAction {
  NSIS_APP_HYDRATED = "NSIS_APP_HYDRATED",
  STORAGE_UNSET_ALL_AUTH_KEY = "[Storage] Unset all Authenticated key",
}
/**
 * Enum to plant store action
 */
export enum PlantsStoreAction {
  ADD_PLANT = "[Plant] Add New Plant",
  UPDATE_PLANT = "[Plant] Update Existing Plant",
  REMOVE_PLANT = "[Plant] Remove Plants",
  CHANGE_WAN_CONNECTION_FLAG = "[Plant] Change WAN Flag",
  CHANGE_PLANT_DEFAULT_SUPERVISION_TO_OPEN = "[Plant] Change plant default supervision to open",
  SELECTED_PLANT_CHANGED = "[Selected Plant] Change selected plant",
  SELECTED_PLANT_CHANGE_CONNECTION_ADDREESS = "[Selected Plant] Selected plant change connection address",
  SELECTED_PLANT_CHANE_WAN_CONNECTION_FLAG = "[Selected Plant] Change WAN flag",
  SELECTED_PLANT_UNSET = "[Selected Plant] Unset selected plant",
  SELECTED_PLANT_CHANGE_DEFAULT_SUPERVISION_TO_OPEN = "[Selected Plant] Change plant default supervision to open",
  OVERWRITE_PLANT = "[Plant] Overwrite all plants",
}

/**
 * Enum to plant store action
 */
export enum BuildingStoreAction {
  ADD_BUILDING = "[Building] Add New Building",
  UPDATE_BUILDING = "[Building] Update Existing Building",
  REMOVE_BUILDING = "[Building] Remove Building",
  CHANGE_WAN_CONNECTION_FLAG = "[Building] Change WAN Flag",
  CHANGE_BUILDING_DEFAULT_SUPERVISION_TO_OPEN = "[Building] Change plant default supervision to open",
  SELECTED_BUILDING_CHANGED = "[Selected Building] Change selected Building",
  SELECTED_BUILDING_CHANGE_CONNECTION_ADDREESS = "[Selected Building] Selected Building change connection address",
  SELECTED_BUILDING_CHANE_WAN_CONNECTION_FLAG = "[Selected Building] Change WAN flag",
  SELECTED_BUILDING_UNSET = "[Selected Building] Unset selected Building",
  SELECTED_BUILDING_CHANGE_DEFAULT_SUPERVISION_TO_OPEN = "[Selected Building] Change Building default supervision to open",
  OVERWRITE_BUILDING = "[Building] Overwrite all plants",
}

/**
 * Enum containing plant-codes store actions
 */
export enum PlantCodesStoreAction {
  PLANT_CODES_UNSET_KEY_STORAGE = "[Plant-codes] Unset key storage",
  PLANT_CODES_LOAD_INIT_START = "[Plant-codes] Start to load plant-codes generic and ABB lists",
  PLANT_CODES_LOAD_FROM_API = "[Plant-codes] Load full plant-codes lists from API",
  PLANT_CODES_LOAD_LAST_MODIFIED_FROM_API = "[Plant-codes] Load last modified plant-codes lists from API",
  PLANT_CODES_LOAD_SUCCESS = "[Plant-codes] Load plant-codes lists success",
  PLANT_CODES_LOAD_ERROR_HANDLING = "[Plant-codes] Start handling error from plant-codes lists loading",
  PLANT_CODES_LOAD_OLD_DATA = "[Plant-codes] Populate plant-codes lists with old data",
  PLANT_CODES_LOAD_ERROR = "[Plant-codes] Load plant-codes lists error",
  PLANT_CODES_SUBSCRIBE_ADDRESS_CHANGE_START = "[Plant-codes] Start subscribe address change",
  PLANT_CODES_SUBSCRIBE_ADDRESS_CHANGE_COMPLETE = "[Plant-codes] Complete subscribe address change",
  PLANT_CODES_ADDRESS_VALUE_CHANGE = "[Plant-codes] Update existing plant code value",
}

/**
 * Authentication action
 */
export enum AuthStoreAction {
  CURRENT_USER_SET = "[Current User] Set current BIGStudio3 user",
  CURRENT_DP_USER_SET = "[Current User] Set current Digital Place user",
  CURRENT_USER_UNSET = "[Current User] Unset current user",
  CURRENT_USER_UPDATE_DATA = "[Current User] Current user update data",
  CURRENT_USER_UPDATE_PASSWORD = "[Current User] Current user update password ",
  CURRENT_USER_UPDATE_CONSENTS = "[Current User] Current user update consents ",
}

/**
 * Client Settings store action
 */
export enum ClientSettingsStoreAction {
  CLIENT_SETTINGS_INIT_COMPLETE = "[Client setting] Complete initialize client settings object ",
  CLIENT_SETTINGS_CREATE_OBJECT = "[Client setting] Create client setting object",
  CLIENT_SETTINGS_SET_LANGUAGE_BY_DEVICE = "[Client setting] Set language by device",
  CLIENT_SETTINGS_UPDATE_GENERIC = "[Client setting] Update client settings generic",
  CLIENT_SETTINGS_UPDATE_SPECIFIC = "[Client setting] Update client specific setting",
  CLIENT_SETTINGS_UPDATE_DEVICE_NAME = "[Client setting] Update device name",
  CLIENT_SETTINGS_UPDATE_DEFAULT_RELAY = "[Client setting] Update default relay",
  CLIENT_SETTINGS_UPDATE_DEFAULT_RELAY_ACTIVATION_TIME = "[Client setting] Update default relay activation time",

  CLIENT_SETTINGS_UPDATE_ENABLE_TIME_LIMIT_RELAY_ACTIVATION = "[Client setting] Update enable maximum time limit to peculiar relay activation time",
  CLIENT_SETTINGS_UPDATE_MAXIMUM_RELAY_ACTIVATION_TIME = "[Client setting] Update maximum time limit to peculiar relay activation time",

  CLIENT_SETTINGS_UPDATE_ENABLERS_LIST_RELAYS_TIMES_LIMIT = "[Client setting] Update enablers list for maximum time limit to relays activation time",
  CLIENT_SETTINGS_UPDATE_MAXIMUM_RELAY_ACTIVATION_TIME_LIST = "[Client setting] Update list of maximum time limits to relay activation time",

  CLIENT_SETTINGS_UPDATE_HELPER = "[Client setting] Update helper",
  CLIENT_SETTINGS_SET_SUPERVISION_FONT_SIZE = "[Client setting] Set supervision font size",
  CLIENT_SETTINGS_SET_DEVICE_SIBO_ID = "[Client setting] Set device SIBO id",
  CLIENT_SETTINGS_UPDATE_KIOSK_MODE = "[Client setting] Update Kiosk Mode",
  CLIENT_SETTINGS_SET_SUPERVISION_VIEW_MODE = "[Client setting] Set supervision view mode",
  CLIENT_SETTINGS_UPDATE_APP_LANGUAGE = "[Client setting] Update app language",
  CLIENT_SETTINGS_UPDATE_SHOW_BUTTON_CONNECTION_EXIT = "[Client setting] Update show button connection exit",
  CLIENT_SETTINGS_UPDATE_KIOSK_MODE_PASSWORD = "[Client setting] Update kiosk mode password",
  CLIENT_SETTINGS_UPDATE_ADMIN_FEATURES_PASSWORD = "[Client setting] Update Admininistrator features password",
  CLIENT_SETTINGS_UPDATE_AUTO_RESTART_ON_BOOT = "[Client setting] Update auto restart on boot",
  CLIENT_SETTINGS_UPDATE_CUSTOM_STARTING_ACCESS_ENVIRONMENT_CATEGORY = "[Client setting] Update custom starting access environment category",
  CLIENT_SETTINGS_UPDATE_ENABLE_REMOTE_LOG = "[Client setting] Update enable remote log",
  CLIENT_SETTINGS_UPDATE_REMOTE_LOG_LEVEL = "[Client setting] Update remote log level",
  CLIENT_SETTINGS_SET_APPLICATION_THEME = "[Client setting] Set application theme",
  CLIENT_SETTINGS_SET_DIGITAL_PLACE_FLAG = "[Client setting] Set Digital Place flag",
  CLIENT_SETTINGS_SET_BRIGTHNESS = "[Client setting] Set data for brightness",
  CLIENT_SETTINGS_SET_TIME_INACTIVITY_SUPERVISION = "[Client setting] Set time inactivity",
  CLIENT_SETTINGS_UPDATE_CARD_READING_MODE = "[Client setting] update card reading mode",
  CLIENT_SETTINGS_UPDATE_NUMBER_EVENTS_BLACK_BOX = "[Client setting] update number events for black box",
}

/**
 * Server settings store action
 */
export enum ServerSettingsStoreAction {
  SERVER_SETTINGS_UNSET_KEY_STORAGE = "[Server Settings] Unset key storage",
  SERVER_SETTINGS_LOAD_COMPLETE = "[Server Settings] Load complete",
  SERVER_SETTINGS_UPDATE_SHOW_STATUS_BAR = "[Server Settings] Update show status bar",
}

/**
 * Notifications store action
 */
export enum NotificationStoreAction {
  NOTIFICATION_UNSET_KEY_STORAGE = "[Notification] Unset key storage",
  NOTIFICATION_LOAD_INIT_START = "[Notification] Start to load list",
  NOTIFICATION_SAVE_INTO_STORAGE = "[Notification] Save into storage",
  NOTIFICATION_LOAD_FROM_API = "[Notification] Load full notification from API",
  NOTIFICATION_LOAD_LAST_MODIFIED_FROM_API = "[Notification] Load last modified notification from API",
  NOTIFICATION_LOAD_SUCCESS = "[Notification] Load notification success",
  NOTIFICATION_LOAD_ERROR = "[Notification] Load notification error",
  NOTIFICATION_INSERT_NOTIFICATION = "[Notification] Insert new notification",
  NOTIFICATION_UPDATE_NOTIFICATION = "[Notification] Update notification",
  NOTIFICATION_DELETE_NOTIFICATION = "[Notification] Delete notification",
  NOTIFICATION_INSERT_NOTIFICATION_COMPLETE = "[Notification] Insert new notification complete",
  NOTIFICATION_UPDATE_NOTIFICATION_COMPLETE = "[Notification] Update notification complete",
  NOTIFICATION_DELETE_NOTIFICATION_COMPLETE = "[Notification] Delete notification complete",
}

/**
 * Gatways store action
 */
export enum GatewayStoreAction {
  GATEWAY_LOAD_START = "[Gateway] Load gateway start",
  GATEWAY_LOAD_SUCCESS = "[Gateway] Load gateway success",
  GATEWAY_LOAD_ERROR_HANDLING = "[Gateway] Handling error form Gateway-list loading",
  GATEWAY_LOAD_OLD_DATA = "[Gateway] Load gateway list with old data",
  GATEWAY_LOAD_ERROR = "[Gateway] Load gateway error",
  GATEWAY_UNSET_LIST = "[Gateway] Unset gateway list",
  GATEWAY_SETTINGS_LOAD_START = "[Gateway settings] Load gateway settings start",
  GATEWAY_SETTINGS_LOAD_SUCCESS = "[Gateway settings] Load gateway settings success",
  GATEWAY_SETTINGS_LOAD_ERROR_HANDLING = "[Gateway settings] Handling error Gateway settings loading",
  GATEWAY_SETTINGS_LOAD_OLD_DATA = "[Gateway settings] Load gateway settings list with old data",
  GATEWAY_SETTINGS_LOAD_ERROR = "[Gateway settings] Load gateway settings error",
  GATEWAY_SETTINGS_UNSET_LIST = "[Gateway settings] Unset gateway settings list",
  GATEWAY_UPDATE_FAILED_BUS_OPERATION_COUNT = "[Gateway] Update failed bus operation count",
  GATEWAY_CONNECTION_STATUS_CHANGED = "[Gateway] Connection status changed",
}

/**
 * Areas store action
 */
export enum AreaStoreAction {
  AREA_UNSET_KEY_STORAGE = "[Area] Unset key storage",
  AREA_LOAD_INIT_START = "[Area] Start to load list",
  AREA_LOAD_FROM_API = "[Area] Load full area from API",
  AREA_LOAD_LAST_MODIFIED_FROM_API = "[Area] Load last modified area from API",
  AREA_LOAD_SUCCESS = "[Area] Load area success",
  AREA_LOAD_ERROR = "[Area] Load area error",
}

/**
 * Addresses tree store action
 */
export enum AddressTreeStoreAction {
  ADDRESS_TREE_UNSET_KEY_STORAGE = "[Address tree] Unset key storage",
  ADDRESS_TREE_LOAD_INIT_START = "[Address tree] Start to load list",
  ADDRESS_TREE_LOAD_FROM_API = "[Address tree] Load full area from API",
  ADDRESS_TREE_LOAD_LAST_MODIFIED_FROM_API = "[Address tree] Load last modified area from API",
  ADDRESS_TREE_LOAD_SUCCESS = "[Address tree] Load area success",
  ADDRESS_TREE_LOAD_ERROR = "[Address tree] Load area error",
}

/**
 * Chart store action
 */
export enum ChartStoreAction {
  CHART_UNSET_KEY_STORAGE = "[Chart] Unset key storage",
  CHART_LOAD_INIT_START = "[Chart] Start to load list",
  CHART_LOAD_FROM_API = "[Chart] Load full charts from API",
  CHART_LOAD_LAST_MODIFIED_FROM_API = "[Chart] Load last modified charts from API",
  CHART_LOAD_SUCCESS = "[Chart] Load Chart success",
  CHART_LOAD_ERROR = "[Chart] Load Chart error",
}

/**
 * Environment store action
 */
export enum EnvironmentStoreAction {
  ENVIRONMENT_UNSET_KEY_STORAGE = "[Environment] Unset key storage",
  ENVIRONMENT_LOAD_INIT_START = "[Environment] Start to load list",
  ENVIRONMENT_LOAD_FROM_API = "[Environment] Load full enviroment from API",
  ENVIRONMENT_LOAD_LAST_MODIFIED_FROM_API = "[Environment] Load last modified environment from API",
  ENVIRONMENT_LOAD_SUCCESS = "[Environment] Load Environment success",
  ENVIRONMENT_LOAD_ERROR = "[Environment] Load environment error",

  ENVIRONMENT_DEVICE_UNSET_KEY_STORAGE = "[Environment Device] Unset key storage",
  ENVIRONMENT_DEVICE_LOAD_INIT_START = "[Environment Device] Start to load list",
  ENVIRONMENT_DEVICE_LOAD_FROM_API = "[Environment Device] Load full enviroment from API",
  ENVIRONMENT_DEVICE_LOAD_LAST_MODIFIED_FROM_API = "[Environment Device] Load last modified environment from API",
  ENVIRONMENT_DEVICE_LOAD_SUCCESS = "[Environment Device] Load Environment success",
  ENVIRONMENT_DEVICE_LOAD_ERROR = "[Environment Device] Load environment error",

  ENVIRONMENT_ACCESS_USER_OPENABLE_UNSET_STORE_ACTION = "[Environment - Access User Openable] Unset store key",
  ENVIRONMENT_ACCESS_USER_OPENABLE_LOAD_FROM_API = "[Environment - Access User Openable] Load full access user openable from API",
  ENVIRONMENT_ACCESS_USER_OPENABLE_LOAD_SUCCESS = "[Environment - Access User Openable] Load access user openable success",
  ENVIRONMENT_ACCESS_USER_OPENABLE_LOAD_ERROR = "[Environment - Access User Openable] Load access user openable error",

  ENVIRONMENT_ACCESS_CONTROL_LOAD_INIT_START = "[Environment] Start to load list enviroment access ceontrol",
  ENVIRONMENT_ACCESS_CONTROL_LOAD_SUCCESS = "[Environment] Load Environment access control success",
  ENVIRONMENT_ACCESS_CONTROL_LOAD_ERROR = "[Environment] Load environment access control error",
}

/**
 * Translation store action
 */
export enum TranslationStoreAction {
  TRANSLATION_UNSET_KEY_STORAGE = "[Translation] Unset key storage",
  TRANSLATION_LOAD_INIT_START = "[Translation] Start to load list",
  TRANSLATION_LOAD_FROM_API = "[Translation] Load full translation from API",
  TRANSLATION_LOAD_LAST_MODIFIED_FROM_API = "[Translation] Load last modified translation from API",
  TRANSLATION_LOAD_SUCCESS = "[Translation] Load translation from API with success",
  TRANSLATION_LOAD_ERROR_HANDLING = "[Translation] Start handling error from translation loading",
  TRANSLATION_LOAD_OLD_DATA = "[Translation] Populate translations with old data",
  TRANSLATION_LOAD_ERROR = "[Translation] Load translation error",
  TRANSLATION_FORCE_RELOAD = "[Translation] Force reload translation",
}

/**
 * QR code store action
 */
export enum QRCodeStoreAction {
  QRCODE_UNSET_KEY_STORAGE = "[QRCode] Unset key storage",
  QRCODE_LOAD_INIT_START = "[QRCode] Start to load list",
  QRCODE_LOAD_FROM_API = "[QRCode] Load full qr code from API",
  QRCODE_LOAD_LAST_MODIFIED_FROM_API = "[QRCode] Load last modified qr code from API",
  QRCODE_LOAD_SUCCESS = "[QRCode] Load qrcode success",
  QRCODE_LOAD_ERROR = "[QRCode] Load qr cdoe error",
}

/**
 * Time slot store action
 */
export enum TimeSlotStoreAction {
  TIMESLOT_UNSET_KEY_STORAGE = "[Timeslot] Unset key storage",
  TIMESLOT_LOAD_INIT_START = "[Timeslot] Start to load list",
  TIMESLOT_LOAD_FROM_API = "[Timeslot] Load full time slot from API",
  TIMESLOT_LOAD_LAST_MODIFIED_FROM_API = "[Timeslot] Load last modified time slot from API",
  TIMESLOT_LOAD_SUCCESS = "[Timeslot] Load time slot success",
  TIMESLOT_LOAD_ERROR_HANDLING = "[Timeslot] Start handling error from time slots loading",
  TIMESLOT_LOAD_OLD_DATA = "[Timeslot] Populate time slot list with old data",
  TIMESLOT_LOAD_ERROR = "[Timeslot] Load time slot error",
  TIMESLOT_GROUP_UNSET_KEY_STORAGE = "[Timeslot Group] Unset key storage",
  TIMESLOT_GROUP_LOAD_INIT_START = "[Timeslot Group] Start to load list",
  TIMESLOT_GROUP_LOAD_FROM_API = "[Timeslot Group] Load full time slot group from API",
  TIMESLOT_GROUP_LOAD_LAST_MODIFIED_FROM_API = "[Timeslot Group] Load last modified time slot group from API",
  TIMESLOT_GROUP_LOAD_SUCCESS = "[Timeslot Group] Load time slot group success",
  TIMESLOT_GROUP_LOAD_ERROR = "[Timeslot Group] Load time slot group error",
}

/**
 * Device card store action
 */
export enum DeviceCardListStoreAction {
  DEVICE_CARD_UNSET_KEY_STORAGE = "[Device Card List] Unset key storage",
  DEVICE_CARD_START_POPULATE_VALID_LIST = "[Device Card List] Start populate valid list",
  DEVICE_CARD_VALID_LIST_SUCCESSFULL_LOADED = "[Device Card List] Valid list loading from server successfull",
  DEVICE_CARD_VALID_LIST_POPULATED = "[Device Card List] End populate valid list with NEW data",
  DEVICE_CARD_VALID_LIST_POPULATED_WITH_OLD_DATA = "[Device Card List] End populate valid list with OLD data ",
  DEVICE_CARD_SKIPPED_POPULATE_VALID_LIST = "[Device Card List] Skipped populate valid list",
  DEVICE_CARD_VALID_LIST_POPULATED_START_ERROR_HANDLING = "[Device Card List] Start handling error populate valid list",
  DEVICE_CARD_VALID_LIST_ERROR_GENERIC_POPULATION = "[Device Card List] Error generic populatation valid list",
  DEVICE_CARD_NEW_CODE_ADDITION_START = "[Device Card List] Handle new code insertion in valid list",
  DEVICE_CARD_ADD_NEW_CODE_AND_CARDOWNER = "[Device Card List] Add new code and possible cardOwner to valid list",
  DEVICE_CARD_EDIT_CODE_VALID_LIST = "[Device Card List] Edit existing code in valid list",
  DEVICE_CARD_REMOVE_CODE_VALID_LIST = "[Device Card List] Remove existing code in valid list and update cardOwner list if needed",
  DEVICE_CARD_HANDLE_NEW_GUEST_TELEGRAM = "[Device Card List] Handle new guest data telegram",
  DEVICE_CARD_GUEST_DATA_TELEGRAM_INVALID = "[Device Card List] Guest data telegram invalid then SKIPPED",
  DEVICE_CARD_SKIPPED_REMOVE_CODE_REQUEST = "[Device Card List] Skipped remove code request ",
  DEVICE_CARD_LOAD_SUBSCRIBE_GUEST_DATA_SERVER_CONFIRMATION_ADDRESSES = "[Device Card List] Load and subsribe guest data and server confirmation addresses",
  DEVICE_CARD_COMPLETE_SUBSCRIBE_GUEST_DATA_SERVER_CONFIRMATION_ADDRESSES = "[Device Card List] Complete load and guest data and server confirmation addresses",
  DEVICE_CARD_SKIP_GUEST_DATA_SERVER_CONFIRMATION_ADDRESSES = "[Device Card List] Subscribe skipped for guest data and server confirmation addresses - MQTT NOT CONNECTED",
  DEVICE_CARD_SERVER_CONFIRMATION_ADDRESS_RECEIVED = "[Device Card List] Handle new server confirmation address",
}

/**
 * History transit store action
 */
export enum HistoryTransitStoreAction {
  HISTORY_TRANSIT_REMOVE_PLANT_REMOVE_RELEATED_HISTORY = "[History Transit] Remove history transit releated to removed plant",
  HISTORY_TRNASIT_START_ADD_NEW_TRANSIT_IN_HISTORY = "[History Transit] Start add new transit in history",
  HISTORY_TRNASIT_COMPLETE_ADD_NEW_TRANSIT_IN_HISTORY = "[History Transit] Compelte add new transit in history",
  HISTORY_TRNASIT_REMOVE_EXISTING_TRANSIT = "[History Transit] Remove existing transit",
}

/**
 * Card environment store action
 */
export enum CardEnvironmentStoreAction {
  CARD_ENVIRONMENT_START_LOAD = "[Card Environment] Start load card environment for specific card ",
  CARD_ENVIRONMENT_LOAD_SUCCES = "[Card Environment] List card environment load success",
  CARD_ENVIRONMENT_LOAD_ERROR = "[Card Environment] List card environment load error",
  CARD_ENVIRONMENT_SWITCH_ACTIVE_START = "[Card Environment] Start switch active/disactive card enviroment",
  CARD_ENVIRONMENT_SWITCH_ACTIVE_SUCCES = "[Card Environment] Success switch active/disactive card enviroment",
  CARD_ENVIRONMENT_SWITCH_ACTIVE_ERROR = "[Card Environment] Error switch active/disactive card enviroment",
  CARD_ENVIRONMENT_ASSIGN_TIMESLOT_START = "[Card Environment] Start update timeslot card enviroment",
  CARD_ENVIRONMENT_ASSIGN_CALENDAR_START = "[Card Environment] Start update calendar card enviroment",
}

/**
 * Card programmer store action
 */
export enum CardProgrammerStoreAction {
  CARD_PROGRAMMER_UNSET_KEY_STORAGE = "[Card Programmer] Unset key storage",
  CARD_PROGRAMMER_START_LOAD = "[Card Programmer] Start load list card programmer ",
  CARD_PROGRAMMER_LOAD_SUCCES = "[Card Programmer] List card programmer load success",
  CARD_PROGRAMMER_LOAD_ERROR = "[Card Programmer] List card programmer load error",
}

/**
 * Black box store action
 */
export enum BlackBoxStoreAction {
  BLACK_BOX_INSERT_ENTRY = "[Black box] Insert entry",
  BLACK_BOX_REMOVE_ENTRY = "[Black box] Remove entry",
  BLACK_BOX_REMOVE_ALL_ENTRY = "[Black box] Remove all entry",
}

/**
 * Scenarios store actions
 */
export enum ScenariosStoreAction {
  SCENARIOS_UNSET_KEY_STORAGE = "[Scenarios] Unset key storage",
  SCENARIOS_LOAD_INIT_START = "[Scenarios] Start to load list",
  SCENARIOS_LOAD_FROM_API = "[Scenarios] Load full scenario from API",
  SCENARIOS_LOAD_LAST_MODIFIED_FROM_API = "[Scenarios] Load last modified scenario from API",
  SCENARIOS_LOAD_SUCCESS = "[Scenarios] Load scenario list success",
  SCENARIOS_LOAD_ERROR = "[Scenarios] Load scenario list error",
  SCENARIO_INSERT_RECEIVED = "[Scenarios] Insert received",
  SCENARIO_UPDATE_RECEIVED = "[Scenarios] Update received",
  SCENARIO_DELETE_RECEIVED = "[Scenarios] Delete received",
  SCENARIO_INSERTED = "[Scenarios] Scenario inserted",
  SCENARIO_UPDATED = "[Scenarios] Scenario updated",
  SCENARIO_DELETED = "[Scenarios] Scenario deleted",
  SCENARIO_SCHEDULE_ASSIGNED = "[Scenarios] Schedule assigned to scenario",
  SCENARIO_SCHEDULE_UNASSIGNED = "[Scenarios] Schedule unassigned from scenario",
  SCENARIO_SCHEDULE_DELETED = "[Scenarios] Schedule deleted",
  SCENARIO_RUNNING_CHANGED = "[Scenarios] Scenario running flag changed",
}

/**
 * Scenarios commands store actions
 */
export enum ScenariosCommandsStoreAction {
  SCENARIOS_COMMANDS_UNSET_KEY_STORAGE = "[Scenarios Commands] Unset key storage",
  SCENARIOS_COMMANDS_LOAD_INIT_START = "[Scenarios Commands] Start to load list",
  SCENARIOS_COMMANDS_LOAD_FROM_API = "[Scenarios Commands] Load commands for scenario from API",
  SCENARIOS_COMMANDS_LOAD_SUCCESS = "[Scenarios Commands] Load commands for scenario success",
  SCENARIOS_COMMANDS_LOAD_ERROR = "[Scenarios Commands] Load commands for scenario error",
  SCENARIOS_COMMANDS_CHANGE_RECEIVED = "[Scenarios Commands] Command change received from broker",
  SCENARIOS_COMMAND_DELETED = "[Scenarios Commands] Command deleted from store",
}
